import { render } from "./lycrud.vue?vue&type=template&id=9fc43fb6&scoped=true"
import script from "./lycrud.vue?vue&type=script&lang=js"
export * from "./lycrud.vue?vue&type=script&lang=js"

import "./lycrud.vue?vue&type=style&index=0&id=9fc43fb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc43fb6"]])

export default __exports__